module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Mail-box-06e482361160fa36bb4638a1cc2f81d7.svg";